import { AttendanceRequestCodes } from '../form/enum/AttendanceRequestTypeCodes.enum';

type Labels = {
  deptProj: string;
  reason: string;
  remarks: string;
  date: string;
  toDate: string;
};

export const getReason = (
  attendanceRequestType: number,
  labels: Labels
): string => {
  if (
    attendanceRequestType === AttendanceRequestCodes.ADDITIONAL_PERMANENT_ACCESS
  ) {
    const { deptProj, remarks } = labels;

    return `${deptProj} | ${remarks}`;
  }

  if (attendanceRequestType === AttendanceRequestCodes.TEMPORARY_ACCESS) {
    const { date, toDate, deptProj, remarks } = labels;

    return `${date} - ${toDate} | ${deptProj} | ${remarks}`;
  }

  if (attendanceRequestType === AttendanceRequestCodes.NO_PUNCH) {
    const { date, reason, remarks } = labels;

    return `Date: ${date} | ${reason} | ${remarks}`;
  }

  if (attendanceRequestType === AttendanceRequestCodes.LATE_PUNCH) {
    const { date, reason, remarks } = labels;

    return `Date: ${date} | ${reason} | ${remarks}`;
  }

  if (attendanceRequestType === AttendanceRequestCodes.TECHNICAL_ISSUE) {
    const { deptProj, remarks } = labels;

    return `${deptProj} | ${remarks}`;
  }

  // covers attendance request types added to the TARequestType dictionary
  // without a dedicated case above (e.g. External Meeting, Training)
  const { date, remarks } = labels;

  return `Date: ${date} | ${remarks}`;
};
export const s = 1;
